import { Amplify } from 'aws-amplify';

const authMode = process.env.REACT_APP_AUTH_MODE || 'cognito';

export const isApiKeyAuth = authMode === 'api_key';

export function configureAmplify() {
  if (isApiKeyAuth) {
    Amplify.configure({
      API: {
        GraphQL: {
          endpoint: process.env.REACT_APP_APPSYNC_URL!,
          region: process.env.REACT_APP_APPSYNC_REGION!,
          defaultAuthMode: 'apiKey',
          apiKey: process.env.REACT_APP_APPSYNC_API_KEY!,
        },
      },
    });
  } else {
    Amplify.configure({
      API: {
        GraphQL: {
          endpoint: process.env.REACT_APP_APPSYNC_URL!,
          region: process.env.REACT_APP_APPSYNC_REGION!,
          defaultAuthMode: 'userPool',
        },
      },
      Auth: {
        Cognito: {
          userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
          userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID!,
        },
      },
    });
  }
}
